export const functionListData = {
  /*
  admin: [
    {
      func_id: '01',
      parent_id: null,
      func_name: 'Dashboard',
      func_type: '0',
      func_api: 'dashboard',
      func_icon: 'dashboard',
      func_path: 'DashBoard',
      role_id: '1',
    },
    {
      func_id: '02',
      parent_id: null,
      func_name: 'Devices',
      func_type: '0',
      func_api: 'devices',
      func_icon: 'list',
      func_path: 'Devices',
      role_id: '1',
    },
    {
      func_id: '03',
      parent_id: null,
      func_name: 'Map',
      func_type: '0',
      func_api: 'map',
      func_icon: 'map',
      func_path: 'Map',
      role_id: '1',
    },
    {
      func_id: '04',
      parent_id: null,
      func_name: 'Alert',
      func_type: '0',
      func_api: '',
      func_icon: 'alert',
      func_path: 'Alert History',
      role_id: '1',
    },
    {
      func_id: '0401',
      parent_id: '04',
      func_name: 'Alert Condition',
      func_type: '0',
      func_api: 'alertCondition',
      func_icon: 'condition',
      func_path: 'Alert Condition',
      role_id: '1',
    },
    {
      func_id: '0402',
      parent_id: '04',
      func_name: 'Alert Email',
      func_type: '0',
      func_api: 'alertEmail',
      func_icon: 'email',
      func_path: 'Alert Email',
      role_id: '1',
    },
    {
      func_id: '0403',
      parent_id: '04',
      func_name: 'Alert History',
      func_type: '0',
      func_api: 'alertHistory',
      func_icon: 'history',
      func_path: 'Alert History',
      role_id: '1',
    },
    {
      func_id: '05',
      parent_id: null,
      func_name: 'User Management',
      func_type: '0',
      func_api: 'userManagement',
      func_icon: 'user',
      func_path: 'User Management',
      role_id: '1',
    },
    {
      func_id: '06',
      parent_id: null,
      func_name: 'System Setting',
      func_type: '0',
      func_api: '',
      func_icon: 'setting',
      func_path: 'System Info',
      role_id: '1',
    },
    {
      func_id: '0601',
      parent_id: '06',
      func_name: 'SubG Config',
      func_type: '0',
      func_api: 'subgConfig',
      func_icon: 'subg',
      func_path: 'SubG Config',
      role_id: '1',
    },
    {
      func_id: '0602',
      parent_id: '06',
      func_name: 'System Info',
      func_type: '0',
      func_api: 'systemInfo',
      func_icon: 'system',
      func_path: 'System Info',
      role_id: '1',
    },
    {
      func_id: '0603',
      parent_id: '06',
      func_name: 'System Time',
      func_type: '0',
      func_api: 'systemTime',
      func_icon: 'time',
      func_path: 'System Time',
      role_id: '1',
    },
    {
      func_id: '0604',
      parent_id: '06',
      func_name: 'System Network',
      func_type: '0',
      func_api: 'systemNetwork',
      func_icon: 'network',
      func_path: 'System Network',
      role_id: '1',
    },
    {
      func_id: '0606',
      parent_id: '06',
      func_name: 'About',
      func_type: '0',
      func_api: 'about',
      func_icon: 'about',
      func_path: 'About',
      role_id: '1',
    },
    {
      func_id: '08',
      parent_id: null,
      func_name: 'Download CSV File',
      func_type: '0',
      func_api: 'downloadCsvFile',
      func_icon: 'csv',
      func_path: 'Download CSV File',
      role_id: '1',
    },
    {
      func_id: '10',
      parent_id: null,
      func_name: 'CSV Log',
      func_type: '0',
      func_api: 'csvLog',
      func_icon: 'document',
      func_path: 'CSV Log',
      role_id: '1',
    },
  ],
  */
  admin: [
    {
      func_id: '12',
      parent_id: null,
      func_name: 'Areas',
      func_type: '0',
      func_api: 'areas',
      func_icon: 'list',
      func_path: 'Areas',
    },
    {
      func_id: '11',
      parent_id: null,
      func_name: 'Gateways',
      func_type: '0',
      func_api: 'gateways',
      func_icon: 'list',
      func_path: 'Gateways',
    },
    {
      func_id: '02',
      parent_id: null,
      func_name: 'Devices',
      func_type: '0',
      func_api: 'devices',
      func_icon: 'list',
      func_path: 'Devices',
    },
    {
      func_id: '03',
      parent_id: null,
      func_name: 'Map',
      func_type: '0',
      func_api: 'map',
      func_icon: 'map',
      func_path: 'Map',
    },
    {
      func_id: '04',
      parent_id: null,
      func_name: 'Dashboard',
      func_type: '0',
      func_api: 'dashboard',
      func_icon: 'dashboard',
      func_path: 'Dashboard',
    },
    {
      func_id: '05',
      parent_id: null,
      func_name: 'Maintenance',
      func_type: '0',
      func_api: 'maintenance',
      func_icon: 'setting',
      func_path: 'Maintenance',
    },
    {
      func_id: '06',
      parent_id: null,
      func_name: 'User Management',
      func_type: '0',
      func_api: 'userManagement',
      func_icon: 'user',
      func_path: 'User Management',
    },
    // {
    //   func_id: '05',
    //   parent_id: null,
    //   func_name: 'SubG Config',
    //   func_type: '0',
    //   func_api: 'subgConfig',
    //   func_icon: 'subg',
    //   func_path: 'SubG Config',
    //   role_id: '1',
    // },
  ],
  nonAdmin: [
    {
      func_id: '11',
      parent_id: null,
      func_name: 'Gateways',
      func_type: '0',
      func_api: 'gateways',
      func_icon: 'list',
      func_path: 'Gateways',
    },
    {
      func_id: '02',
      parent_id: null,
      func_name: 'Devices',
      func_type: '0',
      func_api: 'devices',
      func_icon: 'list',
      func_path: 'Devices',
    },
    {
      func_id: '03',
      parent_id: null,
      func_name: 'Map',
      func_type: '0',
      func_api: 'map',
      func_icon: 'map',
      func_path: 'Map',
    },
    {
      func_id: '04',
      parent_id: null,
      func_name: 'Dashboard',
      func_type: '0',
      func_api: 'dashboard',
      func_icon: 'dashboard',
      func_path: 'Dashboard',
    },
    {
      func_id: '05',
      parent_id: null,
      func_name: 'Maintenance',
      func_type: '0',
      func_api: 'maintenance',
      func_icon: 'setting',
      func_path: 'Maintenance',
    },
  ],
  /*
  editors: [
    {
      func_id: '01',
      parent_id: null,
      func_name: 'Dashboard',
      func_type: '0',
      func_api: 'dashboard',
      func_icon: 'dashboard',
      func_path: 'DashBoard',
      role_id: '2',
    },
    {
      func_id: '02',
      parent_id: null,
      func_name: 'Devices',
      func_type: '0',
      func_api: 'devices',
      func_icon: 'list',
      func_path: 'Devices',
      role_id: '2',
    },
    {
      func_id: '03',
      parent_id: null,
      func_name: 'Map',
      func_type: '0',
      func_api: 'map',
      func_icon: 'map',
      func_path: 'Map',
      role_id: '2',
    },
    {
      func_id: '04',
      parent_id: null,
      func_name: 'Alert',
      func_type: '0',
      func_api: '',
      func_icon: 'alert',
      func_path: 'Alert History',
      role_id: '2',
    },
    {
      func_id: '0401',
      parent_id: '04',
      func_name: 'Alert Condition',
      func_type: '0',
      func_api: 'alertCondition',
      func_icon: 'condition',
      func_path: 'Alert Condition',
      role_id: '2',
    },
    {
      func_id: '0402',
      parent_id: '04',
      func_name: 'Alert Email',
      func_type: '0',
      func_api: 'alertEmail',
      func_icon: 'email',
      func_path: 'Alert Email',
      role_id: '2',
    },
    {
      func_id: '0403',
      parent_id: '04',
      func_name: 'Alert History',
      func_type: '0',
      func_api: 'alertHistory',
      func_icon: 'history',
      func_path: 'Alert History',
      role_id: '2',
    },
    {
      func_id: '05',
      parent_id: null,
      func_name: 'User Management',
      func_type: '0',
      func_api: 'userManagement',
      func_icon: 'user',
      func_path: 'User Management',
      role_id: '2',
    },
    {
      func_id: '06',
      parent_id: null,
      func_name: 'System Setting',
      func_type: '0',
      func_api: '',
      func_icon: 'setting',
      func_path: 'System Info',
      role_id: '2',
    },
    {
      func_id: '0601',
      parent_id: '06',
      func_name: 'SubG Config',
      func_type: '0',
      func_api: 'subgConfig',
      func_icon: 'subg',
      func_path: 'SubG Config',
      role_id: '2',
    },
    {
      func_id: '0602',
      parent_id: '06',
      func_name: 'System Info',
      func_type: '0',
      func_api: 'systemInfo',
      func_icon: 'system',
      func_path: 'System Info',
      role_id: '2',
    },
    {
      func_id: '0603',
      parent_id: '06',
      func_name: 'System Time',
      func_type: '0',
      func_api: 'systemTime',
      func_icon: 'time',
      func_path: 'System Time',
      role_id: '2',
    },
    {
      func_id: '0604',
      parent_id: '06',
      func_name: 'System Network',
      func_type: '0',
      func_api: 'systemNetwork',
      func_icon: 'network',
      func_path: 'System Network',
      role_id: '2',
    },
    {
      func_id: '0606',
      parent_id: '06',
      func_name: 'About',
      func_type: '0',
      func_api: 'about',
      func_icon: 'about',
      func_path: 'About',
      role_id: '2',
    },
    {
      func_id: '08',
      parent_id: null,
      func_name: 'Download CSV File',
      func_type: '0',
      func_api: 'downloadCsvFile',
      func_icon: 'csv',
      func_path: 'Download CSV File',
      role_id: '2',
    },
    {
      func_id: '10',
      parent_id: null,
      func_name: 'CSV Log',
      func_type: '0',
      func_api: 'csvLog',
      func_icon: 'document',
      func_path: 'CSV Log',
      role_id: '2',
    },
  ],
  general: [
    {
      func_id: '01',
      parent_id: null,
      func_name: 'Dashboard',
      func_type: '0',
      func_api: 'dashboard',
      func_icon: 'dashboard',
      func_path: 'DashBoard',
      role_id: '3',
    },
    {
      func_id: '02',
      parent_id: null,
      func_name: 'Devices',
      func_type: '0',
      func_api: 'devices',
      func_icon: 'list',
      func_path: 'Devices',
      role_id: '3',
    },
    {
      func_id: '03',
      parent_id: null,
      func_name: 'Map',
      func_type: '0',
      func_api: 'map',
      func_icon: 'map',
      func_path: 'Map',
      role_id: '3',
    },
    {
      func_id: '04',
      parent_id: null,
      func_name: 'Alert',
      func_type: '0',
      func_api: '',
      func_icon: 'alert',
      func_path: 'Alert History',
      role_id: '3',
    },
    {
      func_id: '0401',
      parent_id: '04',
      func_name: 'Alert Condition',
      func_type: '0',
      func_api: 'alertCondition',
      func_icon: 'condition',
      func_path: 'Alert Condition',
      role_id: '3',
    },
    {
      func_id: '0402',
      parent_id: '04',
      func_name: 'Alert Email',
      func_type: '0',
      func_api: 'alertEmail',
      func_icon: 'email',
      func_path: 'Alert Email',
      role_id: '3',
    },
    {
      func_id: '0403',
      parent_id: '04',
      func_name: 'Alert History',
      func_type: '0',
      func_api: 'alertHistory',
      func_icon: 'history',
      func_path: 'Alert History',
      role_id: '3',
    },
    {
      func_id: '0606',
      parent_id: '06',
      func_name: 'About',
      func_type: '0',
      func_api: 'about',
      func_icon: 'about',
      func_path: 'About',
      role_id: '3',
    },
    {
      func_id: '08',
      parent_id: null,
      func_name: 'Download CSV File',
      func_type: '0',
      func_api: 'downloadCsvFile',
      func_icon: 'csv',
      func_path: 'Download CSV File',
      role_id: '3',
    },
    {
      func_id: '10',
      parent_id: null,
      func_name: 'CSV Log',
      func_type: '0',
      func_api: 'csvLog',
      func_icon: 'document',
      func_path: 'CSV Log',
      role_id: '3',
    },
  ],
  */
};
